<template>
  <router-view />
</template>

<script>
export default {
  name: 'SuppliersIndex'
}
</script>
